/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */

import { fabric } from 'fabric';
import { generateId } from '../../utils';
import { FABRIC_CUSTOM_OBJECT } from '../../utils/constants';

const createComponent = (root) => {
  const width = root.width + root.strokeWidth;
  const height = root.height + root.strokeWidth;

  const container = new fabric.Rect({
    width,
    height,
    left: -root.width / 2 - root.strokeWidth,
    top: -root.height / 2 - root.strokeWidth,
    fill: root.fill,
    stroke: root.stroke,
    strokeWidth: root.strokeWidth,
    strokeDashArray: root.strokeDashArray,
    strokeLineCap: root.strokeLineCap,
    rx: root.rx,
    ry: root.ry,
    objectCaching: false,
  });

  const image = new fabric.Path(
    'M161.49361948725203 62.296352732526344C161.49361948725203 71.14817636626317 154.0547189449333 78.52469606104387 145.12803829415083 78.52469606104387 136.20135764336834 78.52469606104387 129.50634715528147 70.4105243967851 129.50634715528147 62.296352732526344 129.50634715528147 53.444529098789516 136.20135764336834 46.068009404008826 145.12803829415083 46.068009404008826 154.05471894493328 46.068009404008826 161.49361948725203 53.444529098789516 161.49361948725203 62.296352732526344 161.49361948725203 62.296352732526344 161.49361948725203 62.296352732526344 161.49361948725203 62.296352732526344M124.29911677565838 80C120.57966650449899 74.09878424417545 114.628546070644 74.09878424417545 110.90909579948465 80 110.90909579948465 80 110.16520574525276 80.73765196947807 110.16520574525276 80.73765196947807 107.18964552832527 76.31174015260966 104.21408531139778 71.14817636626317 101.98241514870216 66.72226454939477 96.77518476907903 57.87044091565793 88.59239417252843 57.87044091565793 83.38516379290532 66.72226454939477 78.1779334132822 75.5740881831316 69.9951428167316 89.58947560321491 64.78791243710847 98.44129923695172 59.58068205748536 107.29312287068856 64.0440223828766 113.93199059599118 74.45848314212284 113.93199059599118 74.45848314212284 113.93199059599118 131.7380173179771 113.93199059599118 131.7380173179771 113.93199059599118 139.17691786029584 113.93199059599118 142.15247807722332 109.50607877912276 138.43302780606396 102.86721105382014 134.71357753490457 96.22834332851752 128.7624571010496 86.63886772530262 124.29911677565838 80 124.29911677565838 80 124.29911677565838 80 124.29911677565838 80',
    {
      fill: root.stroke,
      strokeWidth: '0',
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      width: 100.9,
      height: 69.86,
      top: 0,
      left: 0,
    },
  );

  image.set({ visible: image.width < width && image.height < height });

  return [container, image];
};

fabric.CustomImage = fabric.util.createClass(fabric.Rect, {
  initialize(options) {
    options || (options = {});
    this.callSuper('initialize', options);
    this.set('name', options.name);
    this.set('id', options.id || generateId());
    this.set('type', FABRIC_CUSTOM_OBJECT.customImage);
    this.on('scaling', () => {
      this.set({
        width: this.width * this.scaleX,
        height: this.height * this.scaleY,
        scaleX: 1,
        scaleY: 1,
        flipX: false,
        flipY: false,
      });
    });
  },
  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.get('id'),
      name: this.get('name'),
    });
  },
  toSVG() {
    const components = createComponent(this);
    let svgString = '';
    components.forEach((c) => {
      svgString += c.toSVG();
    });
    return svgString;
  },
  _render(ctx) {
    const components = createComponent(this);
    components.forEach((component) => component.render(ctx));
  },
});

fabric.CustomImage.fromObject = function (options, callback) {
  return callback(new fabric.CustomImage(options));
};

export function createCustomObj() {
  const rect = new fabric.CustomImage({
    id: generateId(),
    name: 'Image',
    width: 300,
    height: 30,
    fill: '#e6e6e6',
    stroke: '#b3b3b3',
    strokeWidth: 1,
    objectCaching: false,
  });
  return rect;
}

window.fabric.CustomImage = fabric.CustomImage;

export default fabric.CustomImage;
